import React from 'react';
import CustomTextField, { CustomTextFieldProps } from './customTextField';
import IconSearch from 'shared/icons/search';
import { useTheme } from '@mui/material';

export default function SearchTextField({ ...props }: CustomTextFieldProps) {
  const theme = useTheme();

  return (
    <CustomTextField
      InputProps={{
        endAdornment: (
          <IconSearch extColor={theme.palette.text.secondary}></IconSearch>
        ),
      }}
      {...props}
    />
  );
}
